import React from "react";
import styled from "styled-components";
import Typography from "../Typography";
import Button from "../Button";
import { ReactComponent as Alert } from "../../assets/alert.svg";
import { toCapitalCase } from "../../utils/conversion";
interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  itemName: string;
  loading: boolean;
  title: string;
  type?: "delete" | "block" | "unblock";
}

// Styled Modal Overlay with smooth transition for visibility and opacity
const ModalOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
  transition: opacity 0.3s ease, visibility 0s 0.3s; /* Smooth fade effect */
`;

// Styled Modal Content with padding, border radius, and other styling
const ModalContent = styled.div`
  background: white;
  padding: 30px 20px;
  border-radius: 8px;
  width: 450px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1); /* Added subtle shadow for depth */
`;

// Styled button container for aligning the Cancel and Delete buttons
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onClose,
  onDelete,
  itemName,
  loading,
  title,
  type = "delete",
}) => {
  return (
    <ModalOverlay isOpen={isOpen}>
      <ModalContent>
        <div
          style={{
            display: "flex", // Use flexbox
            alignItems: "center", // Center the content vertically
            justifyContent: "center", // Center the content horizontally
            width: 65,
            height: 65,
            borderRadius: "50%", // Make it a perfect circle
            border: "8px solid #FEF3F2",
            backgroundColor: "#FEE4E2",
          }}
        >
          <Alert fill="#FEE4E2" width={35} height={35} />
        </div>

        <Typography style={{ fontSize: 18 }} fontWeight="semibold">
          {title}
        </Typography>
        <Typography
          fontWeight="medium"
          style={{ color: "#667085", fontSize: 16 }}
        >
          Are you sure you want to {type} {itemName}?
        </Typography>
        <ButtonContainer>
          <Button variant="gray" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onDelete} isLoading={loading}>
            {type === "delete" ? "Remove" : toCapitalCase(type)}
          </Button>
        </ButtonContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default DeleteModal;
